<template>
  <div class="cart">
    <h2>Aktuelle Bestellung:</h2>
    <div class="info-row">
      <label>JetTicket OrderID</label>
      <div>{{ orderinfo.JTPOrderID}}</div>
    </div>
    <div class="info-row">
      <label>OrderID</label>
      <div>{{ orderinfo.OrderID}}</div>
    </div>
    <div class="info-row">
      <label>Status</label>
      <div>{{ orderinfo.Status }}</div>
    </div>
    <div class="info-row">
      <label>Offener Betrag</label>
      <div>{{ orderinfo.ToPay | fmtcurrency }}</div>
    </div>
    <div class="info-row">
      <label>Sitzplätze Vollpreis</label>
      <div>{{ fullPriceSeats }}</div>
    </div>
    <div class="info-row">
      <label>Freiplätze</label>
      <div>{{ spacerSeats }}</div>
    </div>

    <p>
      <button @click.stop="$emit('neworder')">Neue Buchung Starten</button>
      <button v-if="cancelableOrder" class="btn btn-black" @click.stop="$emit('cancel')">Bestellung Abbrechen</button>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    orderinfo: {
      type: Object
    },
    seatsInCart: {
      type: Array
    }
  },
  computed: {
    fullPriceSeats() {
      if (Array.isArray(this.seatsInCart)) {
        return this.seatsInCart.filter(s => s.SalesConditionID === 0).length
      }
      return 0
    },
    spacerSeats() {
      if (Array.isArray(this.seatsInCart)) {
        return this.seatsInCart.filter(s => s.SalesConditionID !== 0).length
      }
      return 0
    },
    cancelableOrder() {
      return this.orderinfo && this.orderinfo.JTPOrderID && this.orderinfo.JTPOrderID.indexOf(':') === -1
    }
  }
}
</script>


<style lang="scss" scoped>

.cart {
  padding: 16px;
}

.info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  label {
    font-weight: bold;
  }
  text-transform: uppercase;
}
</style>